module.exports = "/assets/packs/images/af72e6ecb6ff7d2907a07fdbd89a138a.png";